import React, { useEffect, useState } from "react";
// import { Helmet } from "react-helmet-async";
import logo from "./logo.svg";
import "./App.css";
import "./Wolfstyle.css";



import ReactLoading from 'react-loading';
import axios from 'axios';

//toast
import { Bounce, ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Game from "./Game";

function WolfLanding({ip}) {

  const [loading, setLoading] = useState(true);
  const [showSubscribe, setShowSubscribe] = useState(false);

  //params
  const [msisdn, setMsisdn] = useState("");
  const [sourceIp, setSourceIp] = useState("");
  const [productId, setProductId] = useState("");
  const [txId, setTxId] = useState("");
  const [mktId, setMktId] = useState("");


  //product descriptions
  const [productName, setProductName] = useState("");
  const [productPrice, setProductPrice] = useState("");
  const [productFrequency, setProductFrequency] = useState("");
  const [productFound, setProductFound] = useState(false);
  const [optOutKeyword, setOptOutKeyWord] = useState(null);
  const [shortcode, setShortCode] = useState(null);

  const [oneClickFlow, setOneClickFlow] = useState(true);
  const [botMarketing, setBotMarketing] = useState(false);


  useEffect(() => {
    setLoading(true);
    toast.dismiss();

    const urlParams = new URLSearchParams(window.location.search);
    const prodid = urlParams.get('productId');
    const transactionId = urlParams.get('txId');
    const hideLp = urlParams.get('lp');
    const botParam = urlParams.get('bt');
    const hash_id = urlParams.get('hash_id');
    const marketerId = urlParams.get('mktId');





    if (prodid) {
      setProductId(prodid);
    }

    if (transactionId) {
      setTxId(transactionId);
    }

    if (hideLp) {
      setOneClickFlow(false);
    }


    if (botParam) {
      setBotMarketing(true);
    }

    if (hash_id) {
      setMsisdn(hash_id);
    }

    if(marketerId){
      setMktId(marketerId);
    }

    if(productId != "" && msisdn != ""){
      generateConsent(msisdn,"::ffff:105.161.86.144");

    }


    if (productId != "" && !msisdn) {

      getProduct(productId);

      let hashedMsisdn = "";

      //SUBSCRIBE 

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `https://api.mfilter.libroafrica.com/api/request/token/get-hash-token`,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': 'Basic M3ZkaDZnMGJiZ2syY3Njaml2Z2h0ZDcwbjY6MXRhMW1xaHRkNW9tNW1vMTM1bmcwbXA1cHY3bmxxOHZpZTE4djY4YjJvMDJldnR1MTdzZg=='
        }
      };

      axios.request(config)
        .then((response) => {
          if (response.data.status == "000") {
            //he token generated successfully
            let heToken = response.data.token;

            setSourceIp(response.data.ip);
            let source_ip = response.data.ip;

            //get hashed msisdn
            let configFetchMasked = {
              method: 'get',
              maxBodyLength: Infinity,
              url: 'https://identity.safaricom.com/partner/api/v2/fetchMaskedMsisdn',
              headers: {
                'X-App': 'he-partner',
                'X-MessageID': '1234',
                'X-Source-System': 'he-partner',
                'Authorization': 'Bearer ' + heToken
              }
            };

            axios.request(configFetchMasked)
              .then((response) => {
                const responseData = response.data; // Extracting the data from the response
                hashedMsisdn = responseData.ServiceResponse.ResponseBody.Response.Msisdn;

                console.log(hashedMsisdn);
                if (hashedMsisdn.length > 0) {



                  //bypass 1 click flow 
                  if (oneClickFlow) {
                    generateConsent(hashedMsisdn, source_ip);
                  } else {
                    setMsisdn(hashedMsisdn);
                    setLoading(false);
                    setShowSubscribe(true);
                  }



                } else {
                  toast.error('🦄 Please activate your safaricom mobile data!', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    transition: Bounce,
                  });

                  setLoading(false);
                }
              })
              .catch((error) => {
                toast.error('🦄 Please activate your safaricom mobile data!', {
                  position: "top-center",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                  transition: Bounce,
                });
                setLoading(false);

              });
          }
        })
        .catch((error) => {
          toast.error('🦄 Something went wrong! Please try again in a few minutes or contact Support!', {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });

          setLoading(false);


        });

    } else {

      toast.error('Missing product parameter', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });

      setLoading(false);


    }
  }, [productId])


  function getProduct(productId) {

    let success = false;

    //get hashed msisdn
    setLoading(true);
    setShowSubscribe(false);

    let config = {
      method: 'get',
      url: `https://api.mfilter.libroafrica.com/api/request/product?productId=${productId}`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    };

    axios.request(config)
      .then((response) => {
        setProductName(response.data.productName);
        setProductPrice(response.data.price);
        setProductFrequency(response.data.frequency);
        setShortCode(response.data.shortcode);
        setOptOutKeyWord(response.data.optOutKeyWork);


        setProductFound(true);

        success = true;
      })
      .catch((error) => {
        toast.error('🦄 Something went wrong! Product not found!', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      });

    return success;
  }





  function generateConsent(msisdn, source_ip) {
    //get hashed msisdn
    setLoading(true);
    setShowSubscribe(false);

    let config = {
      method: 'get',
      url: `https://api.mfilter.libroafrica.com/api/request/wap-subscribe?hashed_msisdn=${msisdn}&ip=${source_ip}&agent=${navigator.userAgent}&productId=${productId}&txId=${txId}&bt=${botMarketing}&mktId=${mktId}`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    };

    axios.request(config)
      .then((response) => {
        if (response.data.status == "000") {
            window.location.href = response.data.consent_url;
        
        }
      })
      .catch((error) => {
        toast.error('🦄 Something went wrong! Please try again in a few minutes or contact Support!', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });


      });
  }





  function botSubscription(constentUrl) {
    let data = JSON.stringify({
      url: constentUrl
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'http://204.13.234.5:5002/click-button',
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    };

    axios.request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log(error);
      });


  }




  return (

    <>
      {!oneClickFlow ?
        <>
          {/* Main Content */}
          <header className="bg-nu2 header-section">
            <div className="sticky top-0 header xl:py-4 sm:pt-6 pt-8">
              <div className="container">
                <nav className="flex justify-between items-center">
                  <a href="/" className="flex items-center">
                    <img className="sm:w-[40px] w-[25px] sm:h-[40px] h-[25px]" src="/images/logo.png" alt="GameWolf Logo" />
                    <span className="pl-2 xl:text-[32px] lg:text-[28px] md:text-[24px] text-[20px] text-nu1 font-medium">
                      GameWolf
                    </span>
                  </a>
                </nav>
              </div>
            </div>
          </header>

          {/* Hero Section */}
          <section className="lg:pt-[120px] md:pt-20 pt-[60px] bg-nu2 hero-section">
            <div className="container">
              <div className="grid grid-cols-12 gap-4 items-center">
                {/* Left Content */}
                <div className="sm:col-span-6 col-span-12 sm:text-left text-center pb-3 sm:pt-0 pt-4">
                  <p className="text-nu1 sm:pb-3 pb-2">Empowering Gamers</p>
                  <h1 className="lin">
                    Engage, Earn, <br />
                    Explore
                  </h1>

                  <div className="sm:pt-10 pt-6 flex sm:justify-normal justify-center">
                    {showSubscribe &&
                      <button id="btn-subcribe" onClick={() => generateConsent(msisdn, sourceIp)} style={{ "background": "none", "border": "none" }}>
                        {/* <a href="/achievements"> */}
                        <span className="buttonx sm:px-4 px-3 sm:py-3 py-2 text-nu1 text-[16px]">
                          SUBSCRIBE
                        </span>
                        {/* </a> */}
                      </button>
                    }
                  </div>
                </div>

                {/* Right Image Section */}
                <div className="sm:col-span-6 col-span-12 relative z-30">
                  <div className="relative z-0 overflow-hidden">
                    {/* <img className="vert-move" src="/images/hero.png" alt="Hero Image" /> */}
                  </div>

                  <div className="relative z-0 overflow-hidden">
                    <img className="vert-move" src="/games-banner1.png" alt="Hero Image"
                      loading="lazy"
                    />
                  </div>

                  <div className="absolute top-0 right-0 overflow-hidden -z-10 sm:-mt-[60px] -mt-[30px]">
                    <div className="box1 animated infinite rotate-full">
                      <img src="/images/hero-sercel.png" alt="Hero Decoration"
                        loading="lazy"
                      />
                    </div>
                  </div>



                </div>
              </div>
            </div>
          </section>


          {productFound &&

            <div
              className="relative z-[50]"
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                zIndex: "90"
              }}>

              <div style={{
                position: "fixed", bottom: "40px", color: "#000", textAlign: "center", fontSize: "15px", lineHeight: "1rem", fontWeight: "bolder",
                display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", background: "orange", padding: "5px 10px", borderRadius: "10px",
                border: "2px #ff325a solid", maxWidth: "375px", margin: "5px 20px"

              }}>
                <p><b>Product Name : {productName} </b></p>
                <p>Price: {productPrice} KES Daily</p>
                {(optOutKeyword && shortcode) && <p>Send : "{optOutKeyword}" to "{shortcode}"" to Cancel</p>}

              </div>
            </div>
          }
        </>
        :

        <div style={{ height: "100vh", background: "#fff" }}>

        </div>

      }


      <ToastContainer />

    </>
  );
}

export default WolfLanding;


// export async function getServerSideProps(context) {
//       const { req } = context;
//       const ip = req.headers["x-forwarded-for"]?.split(",")[0] || req.headers["x-real-ip"] || req.connection.remoteAddress;
//       return { props: { ip } };
//   }
